import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";

import ListUsers from "./List";
import ShowUsers from "./Show";
export const USERS = "users/eshop-user";

export const resources = {
  isMenu: true,
  icon: <SupervisorAccountIcon />,
  name: USERS,
  title: "eShop",
  list: <ListUsers />,
  show: <ShowUsers />,
  permission: "editions",
};
